import { LdsButton, LdsModal } from "@elilillyco/ux-lds-react";

const CreateNewListModal = ({
  isModalOpen,
  setIsModalOpen,
  openCreateListModal,
}) => {
  /**
   * Checks if user is not HCP SF Marketer
   * Note: INC role cannot create lists at all, so this modal should not be shown for INC
   * This function determines if "Create from scratch" button should be shown
   * HCPSF can only create from existing (no scratch option)
   * @returns
   */
  const role = typeof window !== "undefined" ? sessionStorage.getItem("role") : null;

  const checkSFMarketerRole = () =>
    !(role === "spclty_hub_hcp_sf_marketer");

  return (
    <LdsModal
      open={isModalOpen}
      setModalOpen={setIsModalOpen}
      modalId="createNewListModal"
      modalSizeClass="col-12 col-sm-8 col-md-8 col-lg-8"
      className="text-center"
    >
      <div>
        <h2>Create a new list</h2>
        <p>
          {role === "spclty_hub_hcp_sf_marketer"
            ? "Create a new list from existing, use an existing list as an template"
            : "Create a new list from scratch or use an existing list as an template"}
        </p>
      </div>
      <div className="col-12 col-md-12">
        <LdsButton
          classes="button-icon-right blue-bdr-btn outlined mx-4 mt-4"
          mode="alt"
          onClick={() => {
            openCreateListModal("existing");
          }}
        >
          Create from existing list
        </LdsButton>
        {checkSFMarketerRole() ? (
          <LdsButton
            classes="button-icon-right blue-btn mx-4 mt-4"
            mode="secondary"
            onClick={() => openCreateListModal("new")}
          >
            Create list from scratch
          </LdsButton>
        ) : (
          <></>
        )}
      </div>
    </LdsModal>
  );
};

export default CreateNewListModal;
